(function () {
  'use strict';

  function initCasemiraTopbar() {
    var topbar = document.querySelector('.casemira-topbar');
    if (!topbar) return;

    var items = topbar.querySelectorAll('.casemira-topbar__item');
    if (items.length < 2) return;

    var speed = parseInt(topbar.dataset.rotationSpeed, 10) || 4500;
    var mobileMq = window.matchMedia('(max-width: 1023px)');
    var rotationInterval = null;
    var currentStep = 0;
    var isPaused = false;

    // Rotation pondérée : le -10% (index 1) apparaît 2× plus souvent
    // Cycle : -10% → Service Client → -10% → Satisfait ou remboursé
    var sequence = [1, 0, 1, 2];

    function showIndex(idx) {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === idx);
      });
    }

    function tick() {
      if (isPaused) return;
      currentStep = (currentStep + 1) % sequence.length;
      showIndex(sequence[currentStep]);
    }

    function startRotation() {
      stopRotation();
      /* CASEMIRA PERF (F1 bis) : le serveur rend deja l'element data-index="0"
         en is-active (sections/topbar.liquid). L'ancien code appelait
         showIndex(sequence[0]) = index 1 immediatement a l'init : le bandeau
         changeait de texte (« Service Client Francais » -> « -10% sur votre
         1ere commande ») dans la premiere seconde, a CHAQUE chargement.
         On se cale desormais sur l'element deja actif et on laisse passer un
         intervalle complet avant le premier changement. La ponderation du cycle
         est inchangee : la sequence [1, 0, 1, 2] est simplement parcourue a
         partir de la position de l'index 0.
         Repli : si aucun element n'est actif (retour depuis l'ordinateur, ou
         applyMq a retire is-active), on repart au debut de la sequence. */
      var activeIdx = -1;
      items.forEach(function (item, i) {
        if (item.classList.contains('is-active')) activeIdx = i;
      });
      var startStep = sequence.indexOf(activeIdx);
      if (startStep === -1) {
        startStep = 0;
        showIndex(sequence[0]);
      }
      currentStep = startStep;
      rotationInterval = setInterval(tick, speed);
    }

    function stopRotation() {
      if (rotationInterval) {
        clearInterval(rotationInterval);
        rotationInterval = null;
      }
    }

    function applyMq() {
      if (mobileMq.matches) {
        startRotation();
      } else {
        stopRotation();
        items.forEach(function (item) { item.classList.remove('is-active'); });
      }
    }

    // Pause au touch (laisse le temps de lire ou cliquer)
    topbar.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
    topbar.addEventListener('touchend', function () {
      setTimeout(function () { isPaused = false; }, 1500);
    }, { passive: true });

    // Pause si onglet non visible
    document.addEventListener('visibilitychange', function () {
      isPaused = document.hidden;
    });

    // Clic sur le CTA -10% → ouvrir la pop-up newsletter
    var ctaLinks = topbar.querySelectorAll('[data-open-newsletter-popup]');
    ctaLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var modal = document.querySelector('subscription-popup[id^="SubscriptionModal"]');
        if (!modal) return;
        // Si déjà ouvert, ne rien faire
        if (modal.hasAttribute('active')) return;

        // Figer le scroll : `overflow` sur la RACINE, jamais `position: fixed`
        // sur `body` (correctif D13, même règle que le tiroir panier C4 et que
        // assets/casemira-popup.js).
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbar-width', sbw + 'px');

        // Ouvrir avec le même pattern que le script exit-intent
        var reduit = false;
        try { reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) {}
        modal.removeAttribute('hidden');
        modal.setAttribute('open', '');
        if (reduit) {
          modal.setAttribute('active', '');
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              modal.setAttribute('active', '');
            });
          });
        }
        document.documentElement.classList.add('modal-show');

        // Fermeture : on laisse les handlers existants du popup gérer ça
        // Mais on ajoute un handler pour restaurer le scroll si besoin
        function restoreScroll() {
          if (Math.abs((window.pageYOffset || 0) - scrollY) > 1) window.scrollTo(0, scrollY);
        }

        var overlay = modal.querySelector('.fixed-overlay');
        var closeBtn = modal.querySelector('.drawer__close-btn');

        function closeFromTopbar() {
          modal.removeAttribute('active');
          document.documentElement.classList.remove('modal-show');
          restoreScroll();
          setTimeout(function () {
            modal.setAttribute('hidden', '');
            modal.removeAttribute('open');
          }, 400);
          // Cleanup
          if (overlay) overlay.removeEventListener('click', closeFromTopbar);
          if (closeBtn) closeBtn.removeEventListener('click', closeFromTopbar);
        }

        if (overlay) overlay.addEventListener('click', closeFromTopbar);
        if (closeBtn) closeBtn.addEventListener('click', closeFromTopbar);
      });
    });
    applyMq();

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', applyMq);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(applyMq);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCasemiraTopbar);
  } else {
    initCasemiraTopbar();
  }
})();
